/* Demo stub — brak połączenia z API */
import { getMockAcademyBranchesPage } from "../demo/mockAcademies";
import {
  getMockUserDetail,
  getMockUsersPage,
  mockUserMutationSuccess,
} from "../demo/mockUsers";

export const getUserDetail = getMockUserDetail;
export const getAll = async (pageInfo: any) => getMockUsersPage(pageInfo);
export const getAcademyWithBranches = async (pageInfo: any = {}) =>
  getMockAcademyBranchesPage({
    pageNumber: pageInfo?.pageNumber ?? 1,
    pageSize: pageInfo?.pageSize ?? 50,
    ...pageInfo,
  });
export const createUser = mockUserMutationSuccess;
export const editUser = mockUserMutationSuccess;
export const deactivateUser = mockUserMutationSuccess;
export const activateUser = mockUserMutationSuccess;
export const deleteUser = mockUserMutationSuccess;
